export const WEBCHAT_SOURCE = 'chatbot_site';

export const WEBCHAT_CUSTOMER_IDENTIFIER_PREFIX = 'cliente-';

export const WEBCHAT_VISITOR_IDENTIFIER_PREFIX = 'visitante-';
